export const ROUTES = {
  STATUS: '/onboarding/status',
  SKIP: '/onboarding/skip',
  PATIENT: '/onboarding/patient',
  PATIENT_FINISH: '/onboarding/patient/finish',
  PROFILE: '/onboarding/profile',
  CLINIC: '/onboarding/clinic',
  CLINIC_LOGO_PRESIGN: '/onboarding/clinic/logo/presign',
  CLINIC_LOGO_BY_ID: fileId => `/onboarding/clinic/logo/${fileId}`,
  CLINIC_LOGO: '/onboarding/clinic/logo',
};
